module.exports = __webpack_public_path__ + "img/custom_vip.02090ed2.jpg";